import React, { Component } from "react";
import moment from "moment";

import {
  getItemPresentation,
  getItemMeatPresentation
} from "../../utils/Helpers";

const empty_line = {
  marginTop: "2mm",
};

const ItemsTableHeader = () => {
  const header = { background: "#e9ebec", borderCollapse: "collapse" };
  const border = { border: "1px solid gray" };

  return (
    <thead style={header}>
      <tr>
        <td style={{...border, width: "55px"}}>
          <b>Inv</b>
        </td>
        <td>
          <b>Item name</b>
        </td>
        <td style={{...border, width: "100px"}}>
          <b>Presentation</b>
        </td>
        <td style={{...border, width: "55px"}}>
          <b>Qty</b>
        </td>
      </tr>
    </thead>
  );
};

const ItemsTableRow = ({ item, showItemsWithZeroQty }) => {
  const { inventory, name, amount } = item;
  const presentation = getItemPresentation(item.item);
  const colPadding = { paddingRight: "5px", border: "1px solid gray" };
  const showItem = showItemsWithZeroQty || amount !== 0;
  return (
    showItem && (
      <tr>
        <td style={colPadding}>{inventory ? inventory : "-"}</td>
        <td style={{ ...colPadding, textAlign: "left" }}>
          {name} {item.grade !== null ? `(Grade: ${item.grade})` : ""}
        </td>
        <td style={colPadding}>{presentation ? presentation : getItemMeatPresentation(item.item, item.presentation)}</td>
        <td style={{ ...colPadding, fontWeight: "bold" }}>{amount}</td>
      </tr>
    )
  );
};

const PrintItemsList = (props) => {
  if (props.items && props.items.length > 0) {
    let table = { border: "1px solid gray", width: "100%", textAlign: "center", borderCollapse: "collapse" };
    return (
      <div>
        <div style={empty_line}></div>
        <table style={table}>
          <ItemsTableHeader />
          <tbody>
            {props.items.map((item, index) => {
              return <ItemsTableRow item={item} key={index} showItemsWithZeroQty={props.showItemsWithZeroQty} />;
            })}
          </tbody>
        </table>
      </div>
    );
  } else {
    return null;
  }
};

const PrintOrderHeader = ({ orderId, orderMarket, orderOwner, orderDate, deliveryDate }) => {
  const table = { border: "1px solid gray", width: "100%", borderCollapse: "collapse", textAlign: "center" };
  const tableRow = { border: "1px solid gray" };
  return (
    <div>
      <table style={table}>
        <thead>
          <tr>
            <td style={{...tableRow, width: '30%'}}>
              <b>Order </b>#{orderId}
            </td>
            <td style={{...tableRow, width: '70%'}} colSpan="2">
              <b>From: </b>
              {orderMarket}
            </td>
          </tr>
          <tr>
            <td style={{...tableRow, width: '30%'}}>
              <b>User: </b>
              {orderOwner}
            </td>
            <td style={{...tableRow, width: '35%'}}>
              <b>Date: </b>
              {orderDate ? moment(orderDate).format("L") : "-"}
            </td>
            <td style={{...tableRow, width: '35%'}}>
              <b>Delivery Date: </b>
              {orderDate ? moment(deliveryDate).format("L") : "-"}
            </td>
          </tr>
        </thead>
      </table>
    </div>
  );
};

const PrintStationOrder = (props) => {
  const { station, items, showItemsWithZeroQty } = props;
  let empty_line2 = { marginTop: "8mm" },
    alignLeft = { textAlign: "left" };
  return (
    <div>
      <div style={empty_line2}></div>
      <div style={alignLeft}>
        <b>Station | {station}</b>
      </div>
      <PrintItemsList station={station} items={items} showItemsWithZeroQty={showItemsWithZeroQty} />
    </div>
  );
};

export default class PrintOrderList extends Component {
  render() {
    const { orderId, orderMarket, orderOwner, orderDate, deliveryDate, items, station, index, showItemsWithZeroQty } = this.props;
    let break_after = {
      display: "block",
      pageBreakAfter: "always",
      position: "relative",
      marginTop: "2mm",
    };
    return (
      <div className="orderPrint text-center" id={`toPrint${index}`}>
        <PrintOrderHeader orderId={orderId} orderMarket={orderMarket} orderOwner={orderOwner} orderDate={orderDate} deliveryDate={deliveryDate}/>
        <div style={empty_line}></div>
        <PrintStationOrder station={station} items={items} showItemsWithZeroQty={showItemsWithZeroQty} />
        <div style={break_after}></div>
      </div>
    );
  }
}
